import styled from "@emotion/styled"
import { MainMenu } from "./main-menu"
import VisionValue from "./assets/visionvalueblack.png"
import Phone from "./assets/phone.png"

export const NaviBar = () => {
    return <FloatBar>
        <Logo src={VisionValue} alt={'VISION VALUE'} />
        <MainMenu />
        <PhoneNumber>
            <img src={Phone} style={{ objectFit: 'cover' }} alt={'Phone Number'} />
            <span style={{ fontSize: '1.89rem', fontFamily: '微软雅黑', color: 'white', paddingLeft: '1rem', marginTop: '0.45rem' }}>010-63159020</span>
        </PhoneNumber>
    </FloatBar>
}

const FloatBar = styled.div`
display: flex;
justify-content: center;
align-items: center;
position: relative;
width: 94.58vw;
height: 8rem;
background-color: white;
overflow: hidden;
`

const Logo = styled.img`
width: 16.4rem;
height: 3.2rem;
`

const PhoneNumber = styled.div`
display: flex;
height: 8rem;
width: 24.2rem;
align-items: center;
justify-content: center;
background-color: #c9b17a;
`
